<template>
    <div class="container">
        <Backlink :back="{ name: 'users.index' }" />
        
        <div class="d-flex justify-content-between align-items-start mb-4">
            <div>
                <h2 class="text-muted mb-1">Détails de l'utilisateur</h2>
                <h3 class="mb-0">{{ user.name }} {{ user.prenoms }}</h3>
            </div>
            <button class="btn btn-warning" @click="$router.push({ name: 'users.edit', params: { id: user.id } })">
                <i class="bi bi-pencil-square me-1"></i>Modifier
            </button>
        </div>

        <section-container>
            <p class="fw-bold mb-3">Informations personnelles</p>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <p><span class="text-muted">Téléphone:</span> <strong>{{ formatPhone(user.telephone ?? '') }}</strong></p>
                </div>
                <div class="col-md-6 mb-3">
                    <p><span class="text-muted">Email:</span> <strong>{{ user.email ?? 'Non défini' }}</strong></p>
                </div>
                <div class="col-md-6 mb-3">
                    <p><span class="text-muted">Adresse:</span> <strong>{{ user.adresse ?? 'Non défini' }}</strong></p>
                </div>
                <div class="col-md-6 mb-3">
                    <p><span class="text-muted">Créé le:</span> <strong>{{ formatDate(user.created_at) }}</strong></p>
                </div>
            </div>
        </section-container>

        <section-container>
            <p class="fw-bold mb-3">Rôle et permissions</p>
            <div class="row">
                <div class="col-md-12 mb-3">
                    <p>
                        <span class="badge bg-info fs-5 text-uppercase">
                            {{ user.roleInfo?.long_name ?? 'Non défini' }}
                        </span>
                    </p>
                </div>
            </div>
            
            <div v-if="user.roleInfo?.permissions && user.roleInfo.permissions.length" class="mt-3">
                <h6 class="text-muted mb-2">Permissions:</h6>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="permission in user.roleInfo.permissions" :key="'perm' + permission.id">
                        <div>
                            <p class="fw-bold mb-1">{{ permission.long_name ?? permission.name }}</p>
                            <p class="text-muted small mb-0">{{ permission.description }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </section-container>

        <section-container class="mt-4">
            <div class="d-flex gap-2">
                <button class="btn btn-danger" @click="confirmDeleteUser">
                    <i class="bi bi-trash me-1"></i>Supprimer
                </button>
            </div>
        </section-container>

    </div>
</template>

<script>
import Backlink from '@/components/partials/Backlink.vue';
import SectionContainer from '@/components/elements/SectionContainer.vue';
import dateFormater from '@/helpers/dateFormater';
import { formatPhone } from '@/helpers/textFormater';
import Swal from 'sweetalert2';

export default {
    name: 'UserView',
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    components: {
        Backlink,
        SectionContainer
    },
    data() {
        return {
            user: {}
        }
    },
    methods: {
        ...dateFormater,
        formatPhone,
        getUser() {
            this.$api.get(`/users/${this.id}`)
                .then(response => {
                    this.user = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the user!', error);
                });
        },
        deleteUser() {
            this.$api.delete(`/users/${this.id}`)
                .then(() => {
                    this.$router.push({ name: 'users.index' });
                })
                .catch(error => {
                    console.error('There was an error deleting the user!', error);
                });
        },
        confirmDeleteUser() {
            Swal.fire({
                title: 'Êtes-vous sûr ?',
                text: `Voulez-vous vraiment supprimer l'utilisateur "${this.user.name} ${this.user.prenoms}" ? Cette action est irréversible.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Oui, supprimer',
                cancelButtonText: 'Annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteUser();
                }
            });
        }    },
    created() {
        this.getUser();
    }
}
</script>
